import React from "react";
import { useHistory } from 'react-router-dom';
import { useMutation } from "@apollo/client";

import { Menu, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

import { GRAPHIC_LIST_DELETE } from "graphql/mutation/graphic-packing-gql";
import { errorNotification, successNotification } from "components/request-result";

import GraphicPackingConst from '../graphic-packing-const';
import { EntityRemoveButton, Localize } from 'components/service';
import Icons from 'components/icons';

const basePath = GraphicPackingConst.basePath;

const GraphicPackingActionField = ({ record }) => {
    const history = useHistory();

    const [ graphicListDelete, { loading } ] = useMutation(GRAPHIC_LIST_DELETE,
        {
            update(cache, { data }) {
                const {
                    graphicListDelete: {
                        label,
                        message
                    }
                } = data;

                cache.evict({
                    id: cache.identify({ id: record?.id, __typename: "GraphicList" })
                });
                cache.gc();

                successNotification({
                    title: label,
                    description: message
                });
            },
            onError(error) {
                errorNotification(error);
            }
        }
    );

    const menu = (
        <Menu
            items={ [
                {
                    label: <Localize>MENUS_DROP.Label_Edit</Localize>,
                    key: '1',
                    icon: <Icons.Edit />,
                    onClick: () => history.push(`${ basePath }/${ record.id }`)
                },
                {
                    key: '2',
                    icon: <EntityRemoveButton
                        modalButton={
                            <span style={ { display: 'flex', alignItems: 'center' } }><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span>
                        }
                        nameEntity={ Localize({ children: "ENTITY.Modal_Title_ExhibitionEvent" }).props.children }
                        dataNameEntity={ record.title }
                        loading={ loading }
                        deleteMutation={ graphicListDelete }
                        variables={ {
                            id: record.id,
                        } }
                    />,
                },
            ] }
        />
    );

    return (
        <>
            <Dropdown
                overlay={ menu }
                placement="bottomRight"
                overlayClassName="drop-more-menu"
                arrow
            >
                <EllipsisOutlined className="btn-more" />
            </Dropdown>
        </>
    );
};

export default GraphicPackingActionField;